import { defineComponent as _defineComponent } from 'vue'
interface Props {
  value: string | number;
  hidden?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BasicBadge',
  props: {
    value: null,
    hidden: { type: Boolean }
  },
  setup(__props: any) {



return { __sfc: true, }
}

})